module.exports = __webpack_public_path__ + "img/08.a7fe653c.webp";